import React, { useEffect } from 'react';
import PrimaryAudience from './Components/PrimaryAudience'
import SecondaryAudience from './Components/SecondaryAudience'

const Audience = (props) => {

    useEffect(() => {
        if (props.data) {
            // console.log('audience data', props )
        }
    }, [props.data, props.members, props.audiences]);

    return (
        <div className="row clearfix">
            <div className="col-lg-12 col-md-12 col-sm-12">
                <div className="card card-radius">
                    <div className="header card-header custum-bg-warning rounded">
                        <h2 className="text-white">Audience</h2>
                    </div>
                    <div className="body card-body-shadow">
                        <div className="row clearfix">
                            <div className="col-lg-12 col-md-12">
                                <div className="card">
                                    <div className="body">
                                        <ul className="row nav nav-tabs">
                                            <li className="nav-item"><a className="nav-link text-center active show" data-toggle="tab" href="#PrimaryAudience">Primary Audience</a></li>
                                            <li className="nav-item"><a className="nav-link text-center" data-toggle="tab" href="#SecondaryAudience">Secondary Audience</a></li>
                                        </ul>
                                        <div className="tab-content mt-5">
                                            <div className="tab-pane show active" id="PrimaryAudience">
                                                <PrimaryAudience members={props.members} data={props.data} primaryAudience={props?.audiences?.primary_audience} audienceTypes={props?.audienceTypes} />
                                            </div>
                                            <div className="tab-pane" id="SecondaryAudience">
                                                <SecondaryAudience members={props.members} data={props.data} secondaryAudience={props?.audiences?.secondary_audience} audienceTypes={props?.audienceTypes} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default Audience;